// extracted by mini-css-extract-plugin
export default {"wrapper":"dZCQxjTBztaZbL4uXunc","icon":"pzDQZTzObTpnKNQETPYz","docName":"b3fqxrRm3G_8K6_8zzTw"};